"use client";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 text-center">
      <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-[20px] bg-Background-light text-2xl font-bold text-Primary outline outline-1 outline-Background-dark" aria-hidden="true">
        !
      </span>
      <h2 className="mt-4 text-2xl font-normal text-Black">Bir şeyler ters gitti</h2>
      <p className="mt-2 text-sm text-500">{error.message || "Beklenmeyen bir hata oluştu."}</p>
      <button onClick={() => reset()} className="mt-6 min-h-[44px] rounded-full bg-Primary px-6 py-2.5 text-sm font-medium uppercase text-White transition hover:bg-Primary-dark active:scale-[0.98]">
        Tekrar Dene
      </button>
    </div>
  );
}
